import { AppHttpClient } from '../../core/http/app-http-client.service';
import * as i0 from "@angular/core";
import * as i1 from "../../core/http/app-http-client.service";
var Plans = /** @class */ (function () {
    /**
     * Plans API service constructor.
     */
    function Plans(http) {
        this.http = http;
    }
    /**
     * Get all available projects.
     */
    Plans.prototype.all = function (params) {
        return this.http.get('billing/plans', params);
    };
    /**
     * Get plan matching specified id.
     */
    Plans.prototype.get = function (id) {
        return this.http.get('billing/plans/' + id);
    };
    /**
     * Create a new plan.
     */
    Plans.prototype.create = function (params) {
        return this.http.post('billing/plans', params);
    };
    /**
     * Sync billing plans across all gateways.
     */
    Plans.prototype.sync = function () {
        return this.http.post('billing/plans/sync');
    };
    /**
     * Update plan matching specified id.
     */
    Plans.prototype.update = function (id, params) {
        return this.http.put('billing/plans/' + id, params);
    };
    /**
     * Delete plan matching specified id.
     */
    Plans.prototype.delete = function (params) {
        return this.http.delete('billing/plans', params);
    };
    Plans.ngInjectableDef = i0.defineInjectable({ factory: function Plans_Factory() { return new Plans(i0.inject(i1.AppHttpClient)); }, token: Plans, providedIn: "root" });
    return Plans;
}());
export { Plans };
